import React from 'react';
import '../../style/HomeSide.scss';
// material Ui
import FacebookIcon from '@material-ui/icons/Facebook';
import YouTubeIcon from '@material-ui/icons/YouTube';
import InstagramIcon from '@material-ui/icons/Instagram';
import MailIcon from '@material-ui/icons/Mail';
// React Redux
// import { connect } from 'react-redux';

function HomeSideContent() {
  return (
    <div className='homeSide d-flex flex-column text-left'>
      <div className='announcement'>
        <h4 className='title text-primary'>Announcement</h4>
        <ul>
          <li>
            Lorem ipsum dolor sit amet consectetur constercn adssisnallsi adlai
            Lorem ipsum dolor sit amet consectetur
            <br />
            <a href='#'>Read More...</a>
          </li>
          <li>
            Lorem ipsum dolor sit, amet consectetur adipisicing. dolor sit, amet
            consectetur adipisicing. <br />
            <a href='#'>Read More..</a>
          </li>
        </ul>
      </div>
      <div className='social'>
        <h4 className='title text-primary'>Find Me On</h4>
        <ul className='d-flex justify-content-between'>
          <li>
            <a href='https://www.facebook.com/kunga008'>
              <FacebookIcon fontSize='large' />
            </a>
          </li>
          <li>
            <a href='https://www.youtube.com/user/tsangsarkunga'>
              <YouTubeIcon fontSize='large' />
            </a>
          </li>
          <li>
            <InstagramIcon fontSize='large' />
          </li>
          <li>
            <MailIcon fontSize='large' />
          </li>
        </ul>
      </div>
    </div>
  );
}

export default HomeSideContent;
